module.exports = __webpack_public_path__ + "static/connect-ddeece0361d6c64ce35810a53d52ef77.mp4";